import React, { useState, useEffect, useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { Form, Col, InputGroup, Modal, Button, Row } from 'react-bootstrap';
import Select from "react-dropdown-select";
import styled from "styled-components";
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useFailedImages } from '../../hooks/useFailedImages';

import { UserContext } from '../../context/UserContext';
import NewActor from '../actors/new-actor-popup';
import NewMovie from '../scenes/new-movie-popup.js';
import NewSceneTag from '../scenes/new-scene-tag';
import GarmentManager from '../garment/garment-manager';
import ImageGalleryView from '../gallery/image-gallery-view.js';
import { statusActions } from '../../actions/scene/statusActions';
import { siteActions } from '../../actions/scene/siteActions';
import { sceneActions } from '../../actions/scene/sceneActions';
import { actorActions } from '../../actions/scene/actorActions';
import { movieActions } from '../../actions/movie/movieActions';
import { garmentActions } from '../../actions/garment/garmentActions';
import constants, { sceneCategoryTags, TAGS } from '../../const.js';
import SpinnerLoad from '../common/spinner';

import { getActors, insertSceneActor, removeSceneActor, getTags, getPositions } from '../../controller/sceneController';
import { helper } from '../common/helper';
import NewScenePosition from './new-scene-position.js';
import PositionAdder from './position-adder.js';
import { uploadFileActions } from '../../actions/scene/fileDirectoryActions.js';
import EditActor from '../actors/edit-actor-popup.js';

function EditScene(props) {

    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc)

    const { userState, setUserState } = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);
    const { createBackgroundImageErrorHandler } = useFailedImages();
    const [scene, setScene] = useState({
        site: 0,
        title: "",
        date: "2019-01-01",
        description: "",
        minutes: 0,
        seconds: 0,
        status: 0,
        movie: 0,
        gallery: ""
    })
    const [actors, setActors] = useState({ original: [], selectedActor: [] });
    const [editActor, setEditActor] = useState({
        editActor: false,
        saveActor: false,
        selectedActor: []
    })
    const [tags, setTags] = useState({ original: [], selectedTag: [] });
    const [movies, setMovies] = useState([]);
    const [site, setSite] = useState([]);
    const [editTag, setEditTag] = useState({
        editTag: false,
        saveTag: false,
        selectedTag: []
    })
    const [scenePositions, setScenePositions] = useState([]);
    const [positionLoc, setPositionLoc] = useState(0);
    const [reloadVideo, setReloadVideo] = useState(true);
    const [showGallery, setShowGallery] = useState(false);
    const [floatingPlayer, setFloatingPlayer] = useState(false);
    const [videoTime, setVideoTime] = useState(0);
    const vidRef = useRef(null)

    const [newAlias, setNewAlias] = useState({ title: '', site: 0, movie: 0 });
    const [editingAlias, setEditingAlias] = useState(null); // { aliasid, title, site, movie }

    const setActorsCall = (data) => {
        setActors({ ...actors, original: data, selectedActor: data })
    }
    
    const setTagsCall = (data) => {
        setTags({ ...tags, original: data, selectedTag: data })
    }

    const demoOptions = props.allTag.map((option) => ({
        ...option,
        label: option.name,
        value: option.id
    }));

    var isMobile = window.innerWidth <= constants.mobileSize;
    const token = `?token=${localStorage.getItem('token').slice(7)}`;

    const keydownHandler = (e) => {
        // Arrow key seeking is handled by PositionAdder which respects the configurable skipDuration
        // if (e.keyCode === 13 && e.shiftKey) {
        //     addTag();
        // }
        // if (e.keyCode === 83 && e.shiftKey) {
        //     var btn = document.getElementById("saveBTN")
        //     btn.click();
        // }

        // if (e.keyCode === 67 && e.shiftKey) {
        //     handleCancel()
        // }

        // if(e.keyCode === 80 && e.shiftKey){
        //     playVideo()
        // }

    }

    const refreshData = () => {
        props.getAllSite();
        props.getAllActor();
        props.getAllTags();
        props.getAllMovies();
        props.getAllStatus();
    }

    useEffect(() => {
        if (props.sceneView && show) {
            getPositions(props.sceneId, setScenePositions)
            getActors(props.sceneId, setActorsCall);
            getTags(props.sceneId, setTagsCall);
            var d = new dayjs.utc(props.scene.date);
            setScene({
                site: props.scene.siteId,
                title: props.scene.title,
                date: d.format('YYYY-MM-DD'),
                description: props.scene.description,
                minutes: props.scene.minutes,
                seconds: props.scene.seconds,
                status: props.scene.status,
                movie: props.scene.movie
            })
            setMovies([props.movie])
            setSite([props.site])
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!props.sceneView) {
            var d = new dayjs.utc(props.scene.date);
            setScene({
                site: props.scene.siteId,
                title: props.scene.title,
                date: d.format('YYYY-MM-DD'),
                description: props.scene.description,
                minutes: props.scene.minutes,
                seconds: props.scene.seconds,
                status: props.scene.status,
                movie: props.scene.movie,
                gallery: props.scene.gallery
            })
        }
    }, [props.scene]);

    useEffect(() => {
        document.addEventListener('keydown', keydownHandler)
        return () => document.removeEventListener("keydown", keydownHandler);
    });


    const handleCancel = () => {
        setShow(false);
        setPositionLoc(0);
        setFloatingPlayer(false);
    }

    useEffect(() => {
        if (movies.length != 0)
            setScene({ ...scene, movie: movies[0].id })
    }, [movies]);

    useEffect(() => {
        if (site.length != 0)
            setScene({ ...scene, site: site[0].id })
    }, [site])

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        console.log(scene)
        props.updateScene(props.scene.id, scene);
        if (actors.original != actors.selectedActor) {
            props.updateActor(props.scene.id, actors.selectedActor);
        }
    }
    const handleShow = () => {
        if (!props.sceneView) {
            getActors(props.sceneId, setActorsCall)
            getTags(props.sceneId, setTagsCall);
            props.getScene(parseInt(props.sceneId));
            props.getSceneGarments(props.sceneId);
        }        
        setShow(true)
    };

    const addTag = () => {
        var temp = editTag.selectedTag;
        temp.forEach(element => {
            props.insertSceneTag(props.scene.id, element.id).then(() => {
                refreshTag();
            });
        });

        setEditTag({ ...editTag, selectedTag: [] })
    }

    const refreshTag = () => {
        props.getSceneTag(props.scene.id).then(a => {
            setTagsCall(a.tags)
        })
        props.getSceneGarments(props.scene.id);
    }

    const removeTag = (e) => {
        props.deleteSceneTag(props.scene.id, e.target.getAttribute('value')).then(
            () => { refreshTag() }
        )
    }

    const resetTags = () => {
        props.deleteAllSceneTag(props.scene.id).then(
            () => { refreshTag() }
        )
    }

    const addActor = async () => {
        var temp = editActor.selectedActor;
        await temp.forEach(async (element) => {
            await insertSceneActor(props.scene.id, element.id).then(() => {
                refreshActor();
            }).finally(() => props.renameVideo(props.scene.id))
        });


        setEditActor({ ...editActor, selectedActor: [] })
    }

    const refreshActor = () => {
        getActors(props.scene.id, setActorsCall)
    }

    const removeActor = (e) => {
        removeSceneActor(props.scene.id, e.target.getAttribute('value')).then(
            () => { refreshActor() }
        )
    }

    const jumpVideo = (value) => {
        // vidRef.currentTime = value;
        var vid = document.getElementById(`video-${props.sceneId}`);
        vid.currentTime = value;
    }

    const forwardVideo = (value) => {
        var vid = document.getElementById(`video-${props.sceneId}`);
        if (vid != null)
            vid.currentTime = vid.currentTime + value;
    }

    const rewindVideo = (value) => {
        var vid = document.getElementById(`video-${props.sceneId}`);
        if (vid != null)
            vid.currentTime = vid.currentTime - value;
    }

    const getCurrentTime = () => {
        var vid = document.getElementById(`video-${props.sceneId}`);
        if (vid != null)
            setVideoTime(vid.currentTime);
    };

    const refreshAliases = () => {
        props.getScene(parseInt(props.sceneId));
    };

    const addAlias = () => {
        if (!newAlias.title.trim()) return;
        props.addSceneAlias(props.sceneId, newAlias.title, newAlias.site || 0, newAlias.movie || 0)
            .then(() => {
                setNewAlias({ title: '', site: 0, movie: 0 });
                refreshAliases();
            });
    };

    const deleteAlias = (aliasId) => {
        props.deleteSceneAlias(props.sceneId, aliasId).then(refreshAliases);
    };

    const saveEditAlias = () => {
        if (!editingAlias || !editingAlias.title.trim()) return;
        props.updateSceneAlias(props.sceneId, editingAlias.aliasid, editingAlias.title, editingAlias.site || 0, editingAlias.movie || 0)
            .then(() => {
                setEditingAlias(null);
                refreshAliases();
            });
    };

    return <>
        {props.sceneView ?
            <ModernButton variant="success" size="sm" onClick={handleShow}><EditIcon />Edit Scene</ModernButton> :
            <EditIcon sx={{ fontSize: "28px", cursor: "pointer", color: "#667eea" }} onClick={handleShow} />}


        <ModernModal id={`editSceneModal${props.sceneId}`} size="xl" show={show} onHide={handleCancel} style={{ left: `${positionLoc}%` }}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>

                <Modal.Header closeButton>
                    <Modal.Title>Edit Scene {props.sceneId} Information</Modal.Title>
                </Modal.Header>
                {!props.isFetching ? <Modal.Body>
                    {isMobile ?
                        <FormRow>
                            <Form.Group as={Col} xs="3" style={{ marginBottom: '0px' }}>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    label="Mobile"
                                    checked={userState.mobileEdit}
                                    onChange={() => {
                                        if (userState.mobileEdit) setUserState({ ...userState, mobileEdit: false })
                                        else setUserState({ ...userState, mobileEdit: true })
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col} xs="6" controlId="validationStatus" style={{ marginBottom: '0px' }}>
                                <Form.Label>Status</Form.Label>
                                <select className="form-control" value={scene.status} onChange={(e) => setScene({ ...scene, status: parseInt(e.target.value) })} data-live-search="true">
                                    <option defaultValue={"DEFAULT"}>Select Status</option>
                                    {props.allStatus.map(status => <option key={`mobile-status-${status.id}`} value={status.id}>{status.name} | {status.description}</option>)}
                                </select>
                            </Form.Group>
                            <Form.Group as={Col} xs="3" style={{ marginBottom: '0px' }}>
                                <ModernButton className="w-100" variant="secondary" onClick={() => refreshData()} size="sm"><RefreshIcon /></ModernButton>
                            </Form.Group>

                        </FormRow> : null}

                    <SectionTitle>📝 Basic Information</SectionTitle>
                    <FormRow>
                        <Form.Group as={Col} md="5" controlId="validationTitle" style={{ marginBottom: '0px' }}>
                            <Form.Label>Title</Form.Label>
                            <Form.Control required type="text" placeholder="Enter scene title" defaultValue={props.scene.title} onChange={(e) => setScene({ ...scene, title: e.target.value })} size="sm" />
                            <Form.Control.Feedback type="invalid">Please provide a valid title</Form.Control.Feedback>
                        </Form.Group>
                        {!userState.mobileEdit ? <>
                            <Form.Group as={Col} md="3" controlId="validationMinute" style={{ marginBottom: '0px' }}>
                                <Form.Label>Duration</Form.Label>
                                <InputGroup size="sm">
                                    <Form.Control type="text" placeholder="MM" size="sm" defaultValue={props.scene.minutes} onChange={(e) => setScene({ ...scene, minutes: e.target.value })} style={{ padding: '2px 4px' }} />
                                    <Form.Control type="text" placeholder="SS" size="sm" defaultValue={props.scene.seconds} onChange={(e) => setScene({ ...scene, seconds: e.target.value })} style={{ padding: '2px 4px' }} />
                                </InputGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationStatus" style={{ marginBottom: '0px' }}>
                                <Form.Label>Status</Form.Label>
                                <select className="form-control form-control-sm" value={scene.status} onChange={(e) => setScene({ ...scene, status: parseInt(e.target.value) })} data-live-search="true" style={{ padding: '4px 6px', fontSize: '11px' }}>
                                    <option defaultValue={"DEFAULT"}>Select</option>
                                    {props.allStatus.map(status => <option key={`status-${status.id}`} value={status.id}>{status.name}</option>)}
                                </select>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationDate" style={{ marginBottom: '0px' }}>
                                <Form.Label>Date</Form.Label>
                                <Form.Control type="text" placeholder="YYYY-MM-DD" size="sm" defaultValue={new dayjs.utc(props.scene.date).utc().format('YYYY-MM-DD')} onChange={(e) =>
                                setScene({ ...scene, date: e.target.value })
                                } style={{ padding: '4px 6px', fontSize: '11px' }} />
                            </Form.Group>
                        </> : (
                            <Form.Group as={Col} md="7" controlId="validationDate" style={{ marginBottom: '0px' }}>
                                <Form.Label>Date</Form.Label>
                                <Form.Control type="text" placeholder="YYYY-MM-DD" size="sm" defaultValue={new dayjs.utc(props.scene.date).utc().format('YYYY-MM-DD')} onChange={(e) =>
                                setScene({ ...scene, date: e.target.value })
                                } />
                            </Form.Group>
                        )}
                    </FormRow>
                    <FormRow>
                        {!userState.mobileEdit ?
                            <Form.Group as={Col} md="4" controlId="validationSite" style={{ marginBottom: '0px' }}>
                                <Form.Label>Site</Form.Label>
                                <Select style={{ minWidth: "200px", fontSize: "11px" }} options={props.allSite} placeholder="Select" labelField="name" valueField="id"
                                    color="#000000" searchable="true" sortBy="name" clearable="true" searchBy="name" dropdownHeight="180px" dropdownPosition="auto"
                                    values={[props.site]} onChange={e => setSite(e)} />
                            </Form.Group>
                            : null}

                        <Form.Group as={Col} md={!userState.mobileEdit ? "4" : "12"} controlId="validationMovie" style={{ marginBottom: '0px' }}>
                            <Form.Label>Movie</Form.Label>
                            {!props.isFetchingActor ? <Select style={{ minWidth: "200px", fontSize: "11px" }} options={props.allMovie} placeholder="Select" labelField="title" valueField="id"
                                color="#000000" searchable="true" clearable="true" searchBy="title" sortBy="title" dropdownHeight="160px" dropdownPosition="auto"
                                values={[props.movie]}
                                onChange={(e) => { setMovies(e) }}
                            /> : null}
                        </Form.Group>
                        <Form.Group as={Col} md={!userState.mobileEdit ? "4" : "12"} controlId="validationGallery" style={{ marginBottom: '0px' }}>
                            <Form.Label>Gallery</Form.Label>
                            <Form.Control required type="text" placeholder="Gallery" size="sm" defaultValue={props.scene.gallery} onChange={(e) => setScene({ ...scene, gallery: e.target.value })} style={{ padding: '4px 6px', fontSize: '11px' }} />
                        </Form.Group>
                    </FormRow>

                    {!userState.mobileEdit && <>
                    <SectionTitle>🏷️  Aliases</SectionTitle>
                    <Row className='m-0' style={{ marginBottom: '4px' }}>
                        <div style={{ width: "100%", display: "flex", gap: "6px", marginBottom: "8px", flexWrap: "wrap", alignItems: "center" }}>
                            <Form.Control size="sm" type="text" placeholder="Alias title" value={newAlias.title}
                                onChange={(e) => setNewAlias({ ...newAlias, title: e.target.value })}
                                style={{ flex: 2, minWidth: "120px", maxWidth: "220px" }} />
                            <select className="form-control form-control-sm" value={newAlias.site} style={{ flex: 1, minWidth: "100px", maxWidth: "160px" }}
                                onChange={(e) => setNewAlias({ ...newAlias, site: parseInt(e.target.value) })}>
                                <option value={0}>No Site</option>
                                {props.allSite.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                            </select>
                            <select className="form-control form-control-sm" value={newAlias.movie} style={{ flex: 1, minWidth: "100px", maxWidth: "160px" }}
                                onChange={(e) => setNewAlias({ ...newAlias, movie: parseInt(e.target.value) })}>
                                <option value={0}>No Movie</option>
                                {(Array.isArray(props.allMovie) ? props.allMovie : []).map(m => <option key={m.id} value={m.id}>{m.title}</option>)}
                            </select>
                            <ModernButton variant="light" size="sm" onClick={addAlias}><AddCircleOutlineIcon />Add</ModernButton>
                        </div>
                    </Row>
                    <Row className='m-0' style={{ marginBottom: '12px' }}>
                        {props.aliases.length == 0 ?
                            <div style={{ width: "100%", padding: "8px 12px", backgroundColor: "#e8f4f8", borderRadius: "6px", color: "#333", fontSize: "12px" }}>
                                No aliases
                            </div>
                            :
                            <div style={{ width: "100%" }}>
                                {props.aliases.map(alias => (
                                    <div key={`alias-${alias.aliasid}`} style={{
                                        padding: "6px 8px", marginBottom: "4px", backgroundColor: "#f8f9fb",
                                        borderRadius: "6px", borderLeft: "3px solid #667eea", fontSize: "11px"
                                    }}>
                                        {editingAlias && editingAlias.aliasid === alias.aliasid ? (
                                            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", alignItems: "center" }}>
                                                <Form.Control size="sm" type="text" value={editingAlias.title}
                                                    onChange={(e) => setEditingAlias({ ...editingAlias, title: e.target.value })}
                                                    style={{ flex: 2, minWidth: "100px", maxWidth: "200px" }} />
                                                <select className="form-control form-control-sm" value={editingAlias.site || 0} style={{ flex: 1, minWidth: "90px", maxWidth: "150px" }}
                                                    onChange={(e) => setEditingAlias({ ...editingAlias, site: parseInt(e.target.value) })}>
                                                    <option value={0}>No Site</option>
                                                    {props.allSite.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                                                </select>
                                                <select className="form-control form-control-sm" value={editingAlias.movie || 0} style={{ flex: 1, minWidth: "90px", maxWidth: "150px" }}
                                                    onChange={(e) => setEditingAlias({ ...editingAlias, movie: parseInt(e.target.value) })}>
                                                    <option value={0}>No Movie</option>
                                                    {(Array.isArray(props.allMovie) ? props.allMovie : []).map(m => <option key={m.id} value={m.id}>{m.title}</option>)}
                                                </select>
                                                <ModernButton variant="light" size="sm" onClick={saveEditAlias}><SaveIcon /></ModernButton>
                                                <ModernButton variant="danger" size="sm" onClick={() => setEditingAlias(null)}><CancelIcon /></ModernButton>
                                            </div>
                                        ) : (
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <span style={{ color: "#333" }}>
                                                    <strong>{alias.title}</strong>
                                                    {alias.site && alias.site !== "None" ? ` | ${alias.site}` : ""}
                                                    {alias.movie && alias.movie !== "None" ? ` | ${alias.movie}` : ""}
                                                </span>
                                                <div style={{ display: "flex", gap: "4px" }}>
                                                    <EditIcon sx={{ fontSize: "16px", cursor: "pointer", color: "#667eea" }}
                                                        onClick={() => setEditingAlias({ aliasid: alias.aliasid, title: alias.title, site: alias.siteId || 0, movie: alias.movieId || 0 })} />
                                                    <DeleteIcon sx={{ fontSize: "16px", cursor: "pointer", color: "#ff6b6b" }}
                                                        onClick={() => deleteAlias(alias.aliasid)} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        }
                    </Row>
                    </>}

                    <SectionTitle>🎭 Actors</SectionTitle>
                    <FormRow>
                        <Form.Group as={Col} md="12" controlId="validationActors" style={{ marginBottom: '0px' }}>
                            <div style={{ display: "flex", gap: "6px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <Select style={{ flex: 1, minWidth: "250px", fontSize: "12px" }} multi options={props.allActor} placeholder="Add actor" values={editActor.selectedActor} labelField="name" valueField="id"
                                    color="#000000" searchable="true" sortBy="name" clearable="true" searchBy="name" dropdownHeight="200px" dropdownPosition="auto"
                                    dropdownHandleRenderer={({ state }) => (<span>{state.dropdown ? '−' : '+'}</span>)}
                                    onChange={e => setEditActor({ ...editActor, selectedActor: e })} />
                                <ModernButton variant="light" onClick={addActor} size="sm"><AddCircleOutlineIcon /></ModernButton>
                                <ModernButton variant="light" onClick={refreshActor} size="sm"><RefreshIcon /></ModernButton>
                            </div>
                        </Form.Group>
                    </FormRow>
                    {!userState.mobileEdit && <Row className='m-0' style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))", gap: "6px", marginBottom: "10px" }}>
                        {actors.selectedActor.map(actor => {
                            return <ActorCard key={`actor-${actor.id}`}>
                                <div 
                                    className="actor-image" 
                                    style={{ backgroundImage: `url(${constants.CONTENT_DOMAIN}download/sus-media/actors/${String(actor.id).padStart(4, '0')}/model-large.webp${token})` }}
                                    onError={createBackgroundImageErrorHandler(
                                        `url(/${actor.sexe}-large.webp)`
                                    )}
                                >
                                    <div className="badge" value={actor.id} onClick={removeActor} style={{ width: '24px', height: '24px' }}><CloseIcon value={actor.id} fontSize='small' /></div>
                                    <div style={{ 'position': 'absolute', 'bottom': '4px', 'right': '4px' }}><EditActor actorId={actor.id} status={actor.status} /></div>
                                </div>
                                <div className="actor-name">{actor.name}</div>
                            </ActorCard>
                        })}
                    </Row>}

                    <SectionTitle>🏷️  Tags & Categories</SectionTitle>
                    <FormRow>
                        <Form.Group as={Col} md="12" controlId="validationTags" style={{ marginBottom: '0px' }}>
                            <div style={{ display: "flex", gap: "6px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <Select style={{ flex: 1, minWidth: "250px", fontSize: "12px" }} multi options={props.allTag} placeholder="Add tag" values={editTag.selectedTag} labelField="name" valueField="id"
                                    color="#000000" searchable="true" sortBy="num" clearable="true" searchBy="name"
                                    dropdownHeight="200px" dropdownPosition="auto"
                                    dropdownHandleRenderer={({ state }) => (<span>{state.dropdown ? '−' : '+'}</span>)}
                                    onChange={e => setEditTag({ ...editTag, selectedTag: e })} />
                                <ModernButton variant="light" onClick={addTag} size="sm"><AddCircleOutlineIcon /></ModernButton>
                                <ModernButton variant="light" onClick={refreshTag} size="sm"><RefreshIcon /></ModernButton>
                                <GarmentManager sceneId={props.sceneId} />
                            </div>
                        </Form.Group>
                    </FormRow>
                    {sceneCategoryTags.map((cat, idx) => (
                        <div key={`${cat}${idx}`} style={{ margin: '0px 0px 4px 0px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                            <div style={{ fontWeight: "600", color: "#667eea", fontSize: "11px", textTransform: "uppercase", minWidth: '80px', paddingTop: '2px' }}>{cat}</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: 'center' }}>
                                {helper.findTag(TAGS.SCENECATEGORY, cat, tags.selectedTag).map((tag) =>
                                (<TagBadge key={`tag-scene-${tag.name}`} className={`badge badge-${tag.category==="Actor" ? 'info' : 'secondary'}`}
                                >
                                    <a value={tag.id} onClick={removeTag}>{tag.name}</a>
                                    {cat == 'Outfit' ? <img src={`${constants.CONTENT_DOMAIN}download/sus-media/bodyLocation/${tag.bodyLocation}.png${token}`} style={{ height: '16px' }}></img> : null}
                                </TagBadge>))}
                            </div>
                        </div>
                    ))}

                    {/* {!userState.mobileEdit ? <FormRow>
                        <div style={{ width: "100%", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(70px, 1fr))", gap: "6px", marginTop: "6px", marginBottom: '0px' }}>
                            {helper.findTag(TAGS.SCENECATEGORY, "Outfit", tags.original).map(tag => {
                                return <div key={`outfit-${tag.id}`} style={{ textAlign: "center", padding: "4px", borderRadius: "6px", backgroundColor: "#f8f9fb", transition: "all 0.3s ease" }}>
                                    <img src={`${constants.CONTENT_DOMAIN}download/sus-media/tags/${tag.id}.webp${token}`} style={{ width: "50px", height: "50px", borderRadius: "4px" }}></img>
                                    <span style={{ 'fontSize': '10px', color: "#333", display: "block", marginTop: "2px", fontWeight: "600" }}>{tag.name}</span>
                                </div>
                            })}
                        </div>
                    </FormRow> : null} */}

                    {!userState.mobileEdit && props.sceneGarments.length > 0 ? (
                        <FormRow>
                            <SectionTitle style={{ marginTop: '12px', marginBottom: '8px' }}>👗 Associated Garments ({props.sceneGarments.length})</SectionTitle>
                            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))", gap: "6px", marginBottom: '0px' }}>
                                {props.sceneGarments.map(garment => {
                                    return <div key={`garment-${garment.id}`} style={{ textAlign: "center", padding: "6px", borderRadius: "6px", backgroundColor: "#f8f9fb", transition: "all 0.3s ease", border: "1px solid #e0e0e0" }}>
                                        {garment.image_url ? (
                                            <img 
                                                src={`${constants.CONTENT_DOMAIN}${garment.image_url.replace(".webp", "_flatlay.webp")}${token}`} 
                                                style={{ width: "60px", height: "60px", borderRadius: "4px", objectFit: "cover" }} 
                                                alt={garment.name}
                                            />
                                        ) : (
                                            <div style={{ width: "60px", height: "60px", borderRadius: "4px", backgroundColor: "#e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto", fontSize: "10px", color: "#999" }}>
                                                No Image
                                            </div>
                                        )}
                                        <span style={{ 'fontSize': '10px', color: "#333", display: "block", marginTop: "4px", fontWeight: "600", wordBreak: "break-word" }}>{garment.name}</span>
                                        {garment.color && <span style={{ 'fontSize': '8px', color: "#666", display: "block", marginTop: "2px" }}>{garment.color}</span>}
                                    </div>
                                })}
                            </div>
                        </FormRow>
                    ) : null}


                    {!userState.mobileEdit ?
                        <FormRow >
                            <Form.Group as={Col} md="12" controlId="validationDescription" style={{ marginBottom: '0px' }}>
                                <Form.Label>Description</Form.Label>
                                <Form.Control style={{ height: "70px" }} as="textarea" placeholder="Enter scene description..." defaultValue={props.scene.description} onChange={(e) => setScene({ ...scene, description: e.target.value })} />
                            </Form.Group>
                        </FormRow>
                        : null}

                    {!userState.mobileEdit && props.scene.gallery ? (
                        <>
                            <SectionTitle style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => setShowGallery(v => !v)}>
                                <span>🖼️ Gallery</span>
                                <span style={{ fontSize: '11px', color: '#667eea' }}>{showGallery ? '▼ Hide' : '▶ Show'}</span>
                            </SectionTitle>
                            {showGallery && (
                                <FormRow>
                                    <div style={{ width: '100%' }}>
                                        <ImageGalleryView
                                            id={props.scene.gallery.split('/')[0]}
                                            params={{ album: props.scene.gallery.split('/')[1], displayAlbum: false }}
                                        />
                                    </div>
                                </FormRow>
                            )}
                        </>
                    ) : null}

                    <SectionTitle>🎥 Video</SectionTitle>
                    {!userState.mobileEdit && <FormRow>
                        <Form.Group as={Col} md="12" style={{ marginBottom: '0px' }}>
                            <div style={{ display: "flex", gap: "6px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <ModernButton variant="light" size="sm" onClick={() => {
                                    if (reloadVideo)
                                        setReloadVideo(false);
                                    else
                                        setReloadVideo(true)
                                }} >Reload Video</ModernButton>
                                <ModernButton variant="light" size="sm" onClick={() => props.renameVideo(props.sceneId)}><RefreshIcon />Rename</ModernButton>
                                <a href={`H:/sus-media/scenes/${props.sceneId}`} style={{ padding: "6px 10px", backgroundColor: "#f8f9fb", borderRadius: "6px", textDecoration: "none", color: "#667eea", fontWeight: "600", display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "12px" }}><FolderIcon fontSize="small" />Files</a>
                                <a href={`H:/sus-media/scenes/${props.sceneId}/vid`} style={{ padding: "6px 10px", backgroundColor: "#f8f9fb", borderRadius: "6px", textDecoration: "none", color: "#667eea", fontWeight: "600", display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "12px" }}><FolderIcon fontSize="small" />Video Folder</a>
                                                                <ModernButton variant={floatingPlayer ? "primary" : "light"} size="sm" disabled={!props.scene?.videoUrl} onClick={() => setFloatingPlayer(prev => !prev)} title="Play the video in a movable, resizable window while you edit"><PlayArrowIcon />{floatingPlayer ? "Close Floating Player" : "Floating Player"}</ModernButton>
                            </div>
                        </Form.Group>
                    </FormRow>}
                    <FormRow>
                        <PositionAdder editMode={true} sceneId={props.sceneId} jumpVideo={jumpVideo} scenePositions={scenePositions} duration={props.scene.minutes * 60 + props.scene.seconds} setPositionLoc={setPositionLoc} isMobile={isMobile} videoUrl={`${constants.CONTENT_DOMAIN}${props.scene.videoUrl}${token}`} floatingVideo={floatingPlayer} setFloatingVideo={setFloatingPlayer} />
                    </FormRow>
                </Modal.Body>
                    : <SpinnerLoad />}
                <Modal.Footer>
                    <div className="mr-auto" style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                        <div><NewActor /></div>
                        <div><NewMovie /></div>
                        <div><NewSceneTag /></div>
                        <div><NewScenePosition /></div>
                    </div>
                    {!isMobile ? <ModernButton className="mr-auto" variant="secondary" onClick={refreshData} size="sm"><RefreshIcon /></ModernButton> : null}
                    <ModernButton variant="secondary" onClick={resetTags} size="sm">Reset Tags</ModernButton>
                    <ModernButton variant="danger" onClick={handleCancel} size="sm"><CancelIcon />Cancel</ModernButton>
                    <ModernButton variant="success" id="saveBTN" onClick={handleSubmit} size="sm"><SaveIcon />Save</ModernButton>
                </Modal.Footer>
            </Form>
        </ModernModal>
    </>;
}

const StyledOption = styled.span`
padding: 3px 10px;
color: #555;
border-radius: 3px;
margin: 3px;
cursor: pointer;
display: inline-flex;
flex-direction: row;
border: 1px solid #555;
transition: all 1s ease-in;

span {
  display: none;
  transition: all 1s ease-in;
}

a {
  margin: 0 5px;
}

:hover {
  background: #f2f2f2;

  span {
    display: inline;
    margin: 0 0 0 5px;
    color: red;
  }
}
`;

const ModernModal = styled(Modal)`
  .modal-dialog {
    max-width: 1400px;
    width: 95vw;
  }

  .modal-content {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border: none;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }

  .modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    padding: 12px 20px;
    
    .modal-title {
      font-weight: 700;
      font-size: 18px;
      color: white;
    }

    .btn-close {
      filter: brightness(0) invert(1);
    }
  }

  .modal-body {
    background: #f8f9fb;
    padding: 16px 20px;
    max-height: 85vh;
    overflow-y: auto;
  }

  .modal-footer {
    background: #ffffff;
    border-top: 1px solid #e0e0e0;
    padding: 12px 16px;
    gap: 8px;
  }
`;

const ModernFormGroup = styled(Form.Group)`
  margin-bottom: 8px;

  .form-label {
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .form-control,
  .custom-select {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12px;
    transition: all 0.3s ease;
    background-color: #ffffff;

    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 0.1rem rgba(102, 126, 234, 0.15);
    }
  }

  textarea.form-control {
    resize: vertical;
    min-height: 80px;
  }
`;

const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #333;
  margin: 12px 0 8px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #667eea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ModernButton = styled(Button)`
  border-radius: 6px;
  font-weight: 600;
  padding: 6px 12px;
  transition: all 0.3s ease;
  border: none;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &.btn-success {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
    }
  }

  &.btn-danger {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(255, 107, 107, 0.3);
    }
  }

  &.btn-secondary {
    background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
    color: white;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(149, 165, 166, 0.3);
    }
  }

  &.btn-light {
    background: #ffffff;
    color: #667eea;
    border: 2px solid #667eea;

    &:hover {
      background: #667eea;
      color: white;
      transform: translateY(-2px);
    }
  }
`;

const ActorCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
  padding: 6px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .actor-image {
    height: 100px;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
  }

  .actor-name {
    font-size: 11px;
    font-weight: 600;
    color: #333;
    margin-top: 6px;
    word-break: break-word;
  }

  .badge {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 107, 107, 0.9);
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 107, 107, 1);
      transform: scale(1.1);
    }

    svg {
      color: white;
    }
  }
`;

const TagBadge = styled.div`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 16px;
  margin: 2px;
  font-size: 11px;
  font-weight: 600;
  transition: all 0.3s ease;

  &.badge-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }

  &.badge-secondary {
    background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
    color: white;
  }

  a {
    color: inherit;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    border-radius: 4px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

const VideoContainer = styled.div`
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  margin: 8px 0;

  video {
    width: 100%;
    display: block;
  }
`;

const FormRow = styled(Row)`
  margin-bottom: 4px;

  > div {
    display: flex;
    flex-direction: column;
  }
`;

const InputGroupModern = styled(InputGroup)`
  .input-group-text {
    background: #667eea;
    color: white;
    border: 2px solid #667eea;
    font-weight: 600;
    font-size: 13px;
    border-radius: 8px 0 0 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .form-control,
  .custom-select {
    border: 2px solid #e0e0e0;
    border-left: none;
    border-radius: 0 8px 8px 0;

    &:focus {
      border-color: #667eea;
      box-shadow: none;
    }
  }
`;

const mapStateToProps = (state) => {
    return {
        isFetching: state.sceneReducers.isFetching,
        scene: state.sceneReducers.scene.scene.scene,
        movie: state.sceneReducers.scene.movie,
        site: state.sceneReducers.scene.site,
        tags: state.sceneReducers.scene.scene.tags,
        aliases: state.sceneReducers.scene.aliases,
        allStatus: state.scenes.status.allStatus,
        allSite: state.scenes.site.allSite,
        allTag: state.sceneReducers.tags,
        allMovie: state.movies.movies.movies,
        allActor: state.scenes.actor.allActor,
        sceneGarments: state.garment.sceneGarments,
        isFetchingSceneGarments: state.garment.isFetchingSceneGarments
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getScene: (id) => dispatch(sceneActions.getOnlyScene(id)),
        getAllSite: () => dispatch(siteActions.getAllSite()),
        getAllActor: () => dispatch(actorActions.getAllActor()),
        getAllTags: () => dispatch(sceneActions.getSceneTags()),
        getAllMovies: () => dispatch(movieActions.getAllMovies()),
        getAllStatus: () => dispatch(statusActions.getAllStatus()),

        updateScene: (sceneId, scene) => dispatch(statusActions.updateScene(sceneId, scene)),
        updateActor: (scene, actor) => dispatch(actorActions.updateActor(scene, actor)),

        insertSceneTag: (sceneId, tagId) => dispatch(sceneActions.insertSceneTag(sceneId, tagId)),
        deleteSceneTag: (sceneId, tagId) => dispatch(sceneActions.deleteSceneTag(sceneId, tagId)),
        deleteAllSceneTag: (sceneId) => dispatch(sceneActions.deleteAllSceneTag(sceneId)),
        getSceneTag: (id) => dispatch(sceneActions.getSceneTag(id)),
        renameVideo: (id) => dispatch(uploadFileActions.renameVideo(id)),
        getSceneGarments: (sceneId) => dispatch(garmentActions.getSceneGarments(sceneId)),
        addSceneAlias: (sceneId, title, site, movie) => dispatch(sceneActions.addSceneAlias(sceneId, title, site, movie)),
        updateSceneAlias: (sceneId, aliasId, title, site, movie) => dispatch(sceneActions.updateSceneAlias(sceneId, aliasId, title, site, movie)),
        deleteSceneAlias: (sceneId, aliasId) => dispatch(sceneActions.deleteSceneAlias(sceneId, aliasId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditScene);